import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const createManualDiscount = {
  name: "createManualDiscount" as const,
  input: z.object({
    draftReturnId: zExt.objectId(),
    discountType: z.enum(["percentage", "absolute"]),
    value: z.number().positive(),
  }),
  output: z.object({ discountCode: z.string(), success: z.boolean() }),
};
